export const audioQuery = `
  nodes {
    __typename
    ... on Audio_track {
      databaseId
      duration
      featuredImage {
        node {
          altText
          sourceUrl
        }
      }
      imageSrcset
      slug
      tags {
        nodes {
          name
          slug
        }
      }
      title
    }
    ... on Audio_playlist {
      databaseId
      duration
      featuredImage {
        node {
          altText
          sourceUrl
        }
      }
      imageSrcset
      slug
      title
      tags {
        nodes {
          name
          slug
        }
      }
      tracks {
        trackId
      }
    }
  }
`;
